import InputNumber from './InputNumber';
import InputNumberGroup from './InputNumberGroup';
InputNumber.InputNumberGroup = InputNumberGroup;
export default InputNumber;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-input-number/src/index.js